import services from '@/config/services'

export default class UtilityCodiciIvaService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getCodici(){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/codici-iva`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async createCodice(item){

    let result = {
      codice_iva: null,
      success: false,
    }

    const url = `${this.baseUrl}/utility/codici-iva`

    try {
      let res = await this.http.post(url, {
        data: item
      })
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        codice_iva: result.codice_iva,
        success: result.success,
      }
    }

  }

  async deleteCodice(id){
    let success = false

    const url = `${this.baseUrl}/utility/codici-iva/${id}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

}
